import React from "react";
import { useLang } from "@/lib/i18n";

const PHOTOS = [
  "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/fe3qeztr_A8BE79AF-CE10-4EC3-8805-72DE08E81B2A.png",
  "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/b875fxv2_33F7EF25-1189-4172-A821-C7F8CC39C164.png",
  "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/n0gutrdx_25FD0262-CF45-4B26-8A6B-B1F9F47D12C7.png",
];

export default function Gallery() {
  const { t } = useLang();
  return (
    <div data-testid="gallery-page" className="max-w-[1400px] mx-auto px-4 md:px-12 pt-16 md:pt-24 pb-24 md:pb-32 overflow-x-hidden">
      <span className="text-xs uppercase tracking-[0.32em] text-neon font-bold">{t("gallery.overline")}</span>
      <h1 className="h-display text-5xl md:text-8xl mt-3 break-words">
        {t("gallery.title.1")} <span className="italic font-display text-neon">·</span> {t("gallery.title.2")}
      </h1>
      <p className="text-white/60 mt-4 max-w-xl text-sm md:text-base">{t("gallery.sub")}</p>

      <div className="mt-12 md:mt-14 columns-1 md:columns-2 lg:columns-3 gap-4 [column-fill:_balance]">
        {PHOTOS.map((src, i) => (
          <div key={src} data-testid={`gallery-photo-${i}`}
               className="mb-4 break-inside-avoid overflow-hidden rounded-3xl border border-white/10 group relative">
            <img loading="lazy" decoding="async" src={src} alt=""
                 className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105" />
            <div className="absolute inset-0 ring-0 group-hover:ring-2 group-hover:ring-neon transition" />
          </div>
        ))}
      </div>
    </div>
  );
}
